var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3Next(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#C3CCD4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65042 5.992C8.05442 5.992 7.09442 6.976 7.01042 8.74H8.03042C8.05442 7.576 8.65442 6.892 9.65042 6.892C10.5504 6.892 11.1624 7.408 11.1624 8.26C11.1624 9.076 10.4784 9.652 9.47042 9.652C9.30242 9.652 9.18242 9.652 9.08642 9.64V10.504C9.29042 10.48 9.49442 10.468 9.66242 10.468C10.7904 10.468 11.5104 11.092 11.5104 12.1C11.5104 13.06 10.7184 13.744 9.67442 13.744C8.59442 13.744 7.91042 13.084 7.86242 11.872H6.83042V11.908C6.83042 13.672 7.98242 14.644 9.67442 14.644C11.3784 14.644 12.5904 13.636 12.5904 12.052C12.5904 10.972 12.0624 10.216 11.0544 9.988V9.964C11.8224 9.592 12.2304 8.956 12.2304 8.26C12.2304 6.856 11.2704 5.992 9.65042 5.992Z",
    fill: "#0D1834"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Next);
export default __webpack_public_path__ + "static/media/3-next.844faeb6905216f4e0eaa60e43e6b6e5.svg";
export { ForwardRef as ReactComponent };